import { ImageRetry } from '@openeducation/oe-rn-components';
import React from 'react';
import {
  TouchableWithoutFeedback,
  View,
  StyleProp,
  ImageStyle,
  ViewStyle,
} from 'react-native';

import styles from './image-fragment.style';
import { useColors } from '../../../../../hooks';
import Fragment, { FragmentOptionType } from '../../../../fragment/fragment';
import ThemedText2 from '../../../../themed-text-2';

interface ImageFragmentProps {
  image: string;
  option: FragmentOptionType;
  isSelected: boolean;
  onPress: () => void;
  imageStyle?: StyleProp<ImageStyle>;
  fragmentStyle?: StyleProp<ViewStyle>;
  isComplete?: boolean;
}

export default function ImageFragment({
  option,
  image,
  isSelected = false,
  onPress,
  imageStyle,
  fragmentStyle,
  isComplete = false,
}: ImageFragmentProps) {
  const colors = useColors();

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View
        style={[
          styles.container,
          {
            backgroundColor: colors.background,
            borderColor: isSelected ? colors.primary : colors.borderColor,
          },
        ]}
      >
        <ImageRetry
          accessibilityIgnoresInvertColors
          source={{ uri: image }}
          style={[styles.image, imageStyle]}
        />
        {isComplete ? (
          <ThemedText2
            style={[styles.result, fragmentStyle]}
            fontWeightStyle="bold"
          >
            {option?.text}
          </ThemedText2>
        ) : (
          <Fragment
            containerStyle={styles.containerStyle}
            isSelected={isSelected}
            option={option}
            onPress={onPress}
            type="answer-light"
            placeholderStyle={styles.placeholderStyle}
            fragmentStyle={fragmentStyle}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}
